import { createFileRoute, Link } from '@tanstack/react-router'
import { Home, ArrowLeft } from 'lucide-react'

import { Button } from '@/components/base/button'
import { Container } from '@/components/base/container'
import { Heading } from '@/components/base/heading'
import { useI18n } from '@/i18n/i18n-react'

export const Route = createFileRoute('/$splat')({
	component: NotFound
})

function NotFound() {
	const { L } = useI18n()

	return (
		<div className='flex min-h-screen items-center justify-center bg-gray-50'>
			<Container className='w-full max-w-md'>
				<div className='space-y-6 p-8 text-center'>
					<div className='mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-100'>
						<span className='text-2xl font-bold text-red-600'>404</span>
					</div>

					<div>
						<Heading level='h1' className='text-2xl'>
							{L.Error.PageNotFound()}
						</Heading>
						<p className='text-muted-foreground mt-2 text-sm'>{L.Error.PageNotFoundDescription()}</p>
					</div>

					<div className='flex flex-col justify-center gap-3 sm:flex-row'>
						<Button onClick={() => window.history.back()} className='flex items-center gap-2'>
							<ArrowLeft className='h-4 w-4' />
							{L.General.GoBack()}
						</Button>
						<Link to='/'>
							<Button className='flex items-center gap-2'>
								<Home className='h-4 w-4' />
								{L.General.GoHome()}
							</Button>
						</Link>
					</div>
				</div>
			</Container>
		</div>
	)
}
